
export const Apis = { 
    backEndHealthRoute: 'health'
};
